document.addEventListener('DOMContentLoaded', () => {
  const variantSelector = document.querySelector('.product_detail_main_variants_select');
  const totalPriceElement = document.getElementById('js-product-fuel-add-related-total-price');
  const addCartButton = document.getElementById('js-add-to-cart-button');
  const form = document.querySelector('[data-product-form]');

  const updateSubtotal = () => {
    const selectedOption = variantSelector.options[variantSelector.selectedIndex];
    const basePrice = Number(selectedOption.dataset.price || 0) / 100;

    let accessoryTotal = 0;
    document.querySelectorAll('input[name="related-product"]:checked').forEach(checkbox => {
      const price = Number(document.getElementById(`js-product-add-related-product-price-value-${checkbox.value}`).value || 0);
      accessoryTotal += price / 100;
    });

    const unpackingPrice = $("#select_unpacking option:selected").data("price") || 0;
    const enrgPrice = $("#select_enrg option:selected").data("price") || 0;
    const adapterPrice = $("#select_adapter option:selected").data("price") || 0;

    const total = basePrice + accessoryTotal + unpackingPrice / 100 + enrgPrice / 100 + adapterPrice / 100;

    totalPriceElement.innerText = `￥${total.toLocaleString()}`;
  };

  variantSelector.addEventListener('change', updateSubtotal);
  document.querySelectorAll('input[name="related-product"]').forEach(checkbox => {
    checkbox.addEventListener('change', updateSubtotal);
  });
});
